import styled from 'styled-components';
interface DateFieldProps {
  error?: boolean;
  width?: string;
}

export const Container = styled.div<DateFieldProps>`
  width: ${(props) => (props.width ? `${props.width}rem` : 'auto')};
  input[name='dateField'] {
    ${({ error, theme }) =>
      error &&
      `
    border: 1px solid ${theme.colors.red};
    outline-color: ${theme.colors.red};
  `}
  }
`;
